define 'controller/CategoryController', ['jquery', 'custom/media-query', 'lib/kryptonite', 'lib/owl.carousel'], ($, mq) ->
  class CategoryController

    constructor: (@$el) ->
      container = @$el
      @_articlePictureSlider()
      @_jumpToCategoryInSubnavigation()
      @_initBubbles()

    _initBubbles: ->
      self = this
      activeIndex = $('.category__sub-navigation__bubble.active').index()

      if activeIndex == -1
        activeIndex = 0

      $slider = $('.category__sub-navigation__bubbles')

      if $slider.length > 0
        hasAutoWidth = if $("body").hasClass("full-width") then true else false
        startPosition = activeIndex

        $slider.owlCarousel({
          loop: false,
          autoWidth: hasAutoWidth
          items: 2,
          dots: false,
          nav: false,
          startPosition: startPosition,
          stagePadding: 40,
          slideBy: 2,
          responsive:{
            400:{
              items: 3,
              slideBy: 3
            }
            650:{
              items: 5,
              slideBy: 4
            }
            800:{
              items: 6,
              slideBy: 5
            }
            992:{
              items: 7,
              nav: true,
              stagePadding: 0,
              slideBy: 7
            }
            1181:{
              items: 9,
              nav: true,
              stagePadding: 0,
              slideBy: 9
            }
          },
          onInitialized: ->
            $slider.find("button").removeAttr("role")
            $slider.find("button.owl-prev").attr("aria-label", "Précédant")
            $slider.find("button.owl-next").attr("aria-label", "Suivant")
        })

        container = $('.category__sub-navigation__bubbles__container .owl-stage-outer')
        containerWidth = container.width()
        content = $('.category__sub-navigation__bubbles__container .owl-stage')
        contentWidth = content.width()

        if (containerWidth > contentWidth)
          $('.category__sub-navigation__bubbles__container').addClass('center')

    _putCategoryNavigationOnMobile: ->
      unless $('#categoryNavigation__placeholder').length > 0
        $('#categoryNavigation').after('<div id="categoryNavigation__placeholder"></div>')
        $('#categoryNavigation').insertBefore('.pagecontent')

    _putCategoryNavigationOnDesktop: ->
      if $('#categoryNavigation__placeholder').length > 0
        $('#categoryNavigation').insertBefore('#categoryNavigation__placeholder')
        $('#categoryNavigation__placeholder').remove()

    _resetPageSettings: ->
      $('html, body').css
        overflow: 'initial'
        height: 'auto'

    _articlePictureSlider: ->
      mq.update()
      if mq.up_to_M
        touchstartX = 0
        touchendX = 0

        $('.category,.wishlist').on 'touchstart', '.article__picture-slider img', (e) ->
          touchstartX = e.changedTouches[0].screenX
          return
        $('.category,.wishlist').on 'touchend', '.article__picture-slider img', (e) ->
          touchendX = e.changedTouches[0].screenX
          if touchendX < touchstartX
            slider = $(this)
            sliderPictures = slider.data('pictures')
            sliderPosition = slider.data('position')
            sliderLength = sliderPictures.length
            if sliderPosition == 0
              sliderPosition = sliderLength - 1
            else
              sliderPosition = sliderPosition - 1
            slider.attr 'src', sliderPictures[sliderPosition]
            slider.data 'position', sliderPosition
          if touchendX > touchstartX
            slider = $(this)
            sliderPictures = slider.data('pictures')
            sliderPosition = slider.data('position')
            sliderLength = sliderPictures.length
            if sliderPosition == sliderLength - 1
              sliderPosition = 0
            else
              sliderPosition = sliderPosition + 1
            slider.attr 'src', sliderPictures[sliderPosition]
            slider.data 'position', sliderPosition
          return

      $('.category, .wishlist').on 'click', '.article__picture-slider__next', (e)->
        e.stopPropagation();
        slider = $(this).parent().find('.js-picture-slider')
        sliderPictures = slider.data('pictures')
        sliderPosition = slider.data('position')
        sliderLength = sliderPictures.length
        if sliderPosition == sliderLength - 1
          sliderPosition = 0
        else
          sliderPosition = sliderPosition + 1
        slider.attr 'src', sliderPictures[sliderPosition]
        slider.data 'position', sliderPosition
        return
      $('.category, .wishlist').on 'click', '.article__picture-slider__prev', (e) ->
        e.stopPropagation();
        slider = $(this).parent().find('.js-picture-slider')
        sliderPictures = slider.data('pictures')
        sliderPosition = slider.data('position')
        sliderLength = sliderPictures.length
        if sliderPosition == 0
          sliderPosition = sliderLength - 1
        else
          sliderPosition = sliderPosition - 1
        slider.attr 'src', sliderPictures[sliderPosition]
        slider.data 'position', sliderPosition
        return

    _jumpToCategoryInSubnavigation: ->
      if $('.js-scrollto').length
        if $('.js-scrollto').hasClass('js-scrollto-sub')
          scrollto = $('.js-scrollto').closest('ul').parent().children('a')
        else if $('.js-scrollto').hasClass('js-scrollto-sub-sub')
          scrollto = $('.js-scrollto').closest('ul').closest('ul').parent().children('a')
        else
          scrollto = $('.js-scrollto')
        $('.category__sub-navigation__container').animate { scrollTop: scrollto.offset().top - ($('.category__sub-navigation__container').offset().top) }, 0

    destroy: ->
      @$el.off()